import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { readStoredUser } from 'utils/authSession';

function normalizeUserRecord(user) {
  if (!user) return null;
  if (typeof user.toJS === 'function') return user.toJS();
  return user;
}

/**
 * Resolves the active session user — merges Redux + localStorage (page refresh).
 * Matches Topbar / route guard session resolution.
 */
export function useCurrentUser() {
  const fromStore = useSelector((state) => state.getIn(['auth', 'currentUser']));

  return useMemo(() => {
    const storeUser = normalizeUserRecord(fromStore);
    const storedUser = readStoredUser();

    if (storeUser && storedUser) {
      return { ...storedUser, ...storeUser };
    }
    return storeUser || storedUser;
  }, [fromStore]);
}
